import { z } from 'zod';
export const HighRiskTransactionSchema = z.object({
    reference_numbers: z.array(z.string()),
    label: z.string(),
    reason: z.string(),
    evidence: z.array(z.string())
});
export const HighRiskClusterSchema = z.object({
    cluster_type: z.string(),
    reference_numbers: z.array(z.string()),
    summary: z.string(),
    evidence: z.array(z.string())
});
export const FlaggedTransactionsSchema = z.object({
    highRiskTransactions: z.array(HighRiskTransactionSchema).nullish(),
    highRiskClusters: z.array(HighRiskClusterSchema).nullish()
}).meta({
    id: 'FlaggedTransactions'
});

//# sourceMappingURL=flagged-transactions.schema.js.map